import _ from 'underscore';
import { useCallback, useMemo } from 'react';

import {
  useAdPreviewModel as useAdPreviewModelCore,
} from '@bingads-webui-campaign-react/unified-ad-preview-library-core';

import {
  MediaPlacementTypeToPlacementTypeMap,
  PlacementType2MediaPlacementTypeMap,
} from './media-placement-type-enum';


// // this is the same shape as MT response
// type MTPlacementCroppingParam = {
//   MediaPlacementType: EMediaPlacementType,
//   CropSetting: TCropRect,
// }

// // this is the same shape as MT response
// type MTImageParam = {
//   id: number | undefined | null,
//   url: string,
//   width: number,
//   height: number,
//   originalUrl: string,
//   originalWidth: number,
//   originalHeight: number,
//   cropSettingOnOriginal: TCropRect | undefined | null,
//   placementSettings: Array<MTPlacementCroppingParam> | undefined | null,
// }

// const transformCroppingParam = (param: MTPlacementCroppingParam): Array<UAPPlacementCroppingParam> => {
const transformCroppingParam = (param) => {
  const { MediaPlacementType, CropSetting } = param || {};
  const placementTypes = MediaPlacementTypeToPlacementTypeMap[MediaPlacementType];
  if (!_.isEmpty(placementTypes)) {
    return _.map(placementTypes, placementType => ({ placementType, cropping: CropSetting }));
  }
  return [];
};

// const transformImageParam = (image: MTImageParam): UAPPreviewImageParam => {
const transformImageParam = (image) => {
  const {
    id, url, width, height, originalUrl, originalWidth, originalHeight, cropSettingOnOriginal, placementSettings, roiInfo, expandedMeta,
  } = image || {};
  const imageParam = {
    id,
    url,
    width,
    height,
    originalUrl,
    originalWidth,
    originalHeight,
    imageCropping: cropSettingOnOriginal,
    placementsCropping: _.flatten(_.map(placementSettings, transformCroppingParam)),
    roiInfo,
    expandedMeta,
  };
  return imageParam;
};

const transformImage = (image) => {
  if (!image || _.isString(image)) {
    return image;
  }
  return transformImageParam(image);
};


// type TPlacementConfig = Array<{
//   image: string | MTImageParam,
//   placementSets: Array<{
//     placementSetName: string,
//     placementTypes: Array<EPlacementType>,
//     // (params: { imageMeta: TImageMeta, imageCropping: TCropRect, placementMetaList: Array<TPlacementMeta> }) => Array<TCropRect>;
//     getDefaultPlacementsCropping?: Function,
//   }>,
// }>;

// a simple wrapper to adapt the MT type to the core model
// export const useAdPreviewModel = (placementConfig: TPlacementConfig, onError) => {
export const useAdPreviewModel = (placementConfig, onError, { patchPlacementList } = {}) => {
  //
  const transformedConfig = useMemo(() => _.map(placementConfig, ({ image, placementSets }) => ({
    image: transformImage(image),
    placementSets,
  })), [placementConfig]);

  const {
    setPlacementConfig: setPlacementConfigCore,
    changedCropSettings: changedCropSettingsCore,
    ...rest
  } = useAdPreviewModelCore(transformedConfig, onError, { patchPlacementList });

  // const setPlacementConfig = useCallback((config: TPlacementConfig) => {
  const setPlacementConfig = useCallback((config) => {
    const newConfig = _.map(config, ({ image, placementSets }) => ({
      image: transformImage(image),
      placementSets,
    }));
    return setPlacementConfigCore(newConfig);
  }, [setPlacementConfigCore]);

  const changedCropSettings = useMemo(() => {
    const ret = _.map(changedCropSettingsCore, ({ image, placements }) => {
      const imageCropping = image.hasCroppingChanged ? image.imageCropping : null;
      const placementSettings = _.chain(placements)
        .map(({ placementMeta, hasCroppingChanged, placementCropping }) => {
          if (hasCroppingChanged) {
            return { MediaPlacementType: PlacementType2MediaPlacementTypeMap[placementMeta.placementType], CropSetting: placementCropping };
          }
          return null;
        })
        .compact()
        .reduce((acc, placementCropping) => {
          // remove duplicated placement settings
          const { MediaPlacementType } = placementCropping;
          if (!acc[MediaPlacementType]) {
            acc[MediaPlacementType] = placementCropping;
          }
          return acc;
        }, {})
        .value(); // get chain result

      return {
        cropSettings: imageCropping,
        placementSettings: _.compact(_.values(placementSettings)) || [],
      };
    });
    return ret;
  }, [changedCropSettingsCore]);

  return { setPlacementConfig, changedCropSettings, ...rest };
};
